<template>
  <div class="posterList">
    <el-card>
      <el-button
        type="primary"
        slot="header"
        size="medium"
        @click="jump"
      >{{$t('lang.addposterBtn')}}</el-button>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.posterListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="type" :label="$t('lang.lab_sloganclassification')" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">{{$t('lang.POSTER.SERVICE[0].label')}}</span>
          </template>
        </el-table-column>
        <!-- 标语内容 -->
        <el-table-column :label="$t('lang.lab_papercontent')" prop="content" width="400px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span>{{ scope.row.content }}</span>
              </div>
              <div class="conctentstyle">
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="conctentstyle">{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 跳转链接 -->
        <el-table-column prop="url" :label="$t('lang.lab_jumplink')" width="380px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.url&&scope.row.url.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span>{{ scope.row.url }}</span>
              </div>
              <div class="conctentstyle">
                {{ scope.row.url.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.url.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="conctentstyle">{{ scope.row.url | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="deadline" :label="$t('lang.lab_Sloganvalidityperiod')" width="380">
          <template
            slot-scope="scope"
          >{{ scope.row.beginTime | time }} - {{ scope.row.endTime | time }}</template>
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
          fixed="right"
          :width="require('@/config/enum').opr_width2"
        >
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button
              class="orange"
              @click="deletetable(scope.row.id)"
            >{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="title"
      @closed="handleDialogClosed"
    >
     
        <el-form
          :rules="rules"
          ref="form"
          :model="form"
          :label-width="require('@/config/enum').c_ws4"
          :label-suffix="require('@/config/enum').c_colon"
        >
          <!-- <el-form-item :label="$t('lang.lab_sloganclassifications')" prop="type">
            <el-select class="select" v-model="form.type" :disabled="true">
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item :label="$t('lang.lab_sloganclassifications')">
            <template>{{$t('lang.posterservice')}}</template>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_slogancontents')" prop="content">
            <el-input
              maxlength="100"
              v-model="form.content"
              :placeholder="$t('lang.lab_please_Input')+$t('lang.postercontent')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_jumplinks')" prop="url">
            <el-input
              maxlength="100"
              v-model="form.url"
              :placeholder="$t('lang.lab_please_Input')+$t('lang.posterlink')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_uptimes')" prop="beginTime">
            <div class="block">
              <el-date-picker
                v-model="form.beginTime"
                type="date"
                value-format="timestamp"
                :placeholder="$t('lang.selecttimes')"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_downtimes')" prop="endTime">
            <div class="block">
              <el-date-picker
                v-model="form.endTime"
                type="date"
                value-format="timestamp"
                :placeholder="$t('lang.selecttimes')"
              ></el-date-picker>
            </div>
          </el-form-item>
        </el-form>
      
      <div slot="footer">
        <el-button @click="handleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <el-button
          type="primary"
          :disabled="isDisabled"
          @click="onSubmit('form')"
        >{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:posterList
 *@Description:标语管理
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-02-19
 */
export default {
  data() {
    return {
      title: this.$i18n.t('lang.modifyposter'), // 切换修改新增title
      id: '', // 区分新增和修改
      saveData: '', // 存储json字符串
      isDisabled: true, // 确定按钮置灰
      form: {
        type: 1,
        content: '',
        url: '',
        beginTime: Date.parse(new Date()),
        endTime: Date.parse(new Date())
      }, // 详情对象
      // status: this.$i18n.t('lang.POSTER.SERVICE'), // 下拉列表
      show: false, // 弹框开关
      pageCount: 0, // 总页数
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      tableData: [], // 查询list
      rules: {
        type: [
          {
            required: true,
            message: this.$i18n.t('lang.postertypes'),
            trigger: 'change'
          }
        ],
        content: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.postercontent'),
            trigger: 'blur'
          }
        ],
        url: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_jumplink'), trigger: 'blur' }],
        beginTime: [
          {
            required: true,
            message: this.$i18n.t('lang.posteruptime'),
            trigger: 'blur'
          }
        ],
        endTime: [
          {
            required: true,
            message: this.$i18n.t('lang.posterdowntime'),
            trigger: 'blur'
          }
        ]
      },
      posterListcheckbox: require('@/config/enum').posterListcheckbox // 是否隐藏复选框
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.list()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // CHECKBOX
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 监听关闭dialog
    handleDialogClosed() {
      // this.form.type = ''
      this.form.content = ''
      this.form.url = ''
      this.form.beginTime = Date.parse(new Date())
      this.form.endTime = Date.parse(new Date())
      this.$refs.form.clearValidate()
    },
    // 标语列表
    list() {
      let loading = this.$loading()
      this.$get(
        `/slogan?pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.list()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.list()
    },
    // 通过id查询详情对象
    edit(id) {
      this.title = this.$i18n.t('lang.modifyposter')
      this.id = id
      let loading = this.$loading()
      this.$get(`/sloganById/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form = res
            this.saveData = JSON.stringify(this.form)
            this.show = true
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 新增
    jump() {
      this.show = true
      this.id = ''
      this.title = this.$i18n.t('lang.addposterBtn')
    },
    // 修改保存
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.id === '') {
            let params = {
              type: 1,
              content: this.form.content,
              url: this.form.url,
              beginTs: this.form.beginTime,
              endTs: this.form.endTime
            }
            let loading = this.$loading()
            this.$post(`/slogan/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.commit()
                  this.show = false
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let params = {
              type: 1,
              content: this.form.content,
              url: this.form.url,
              beginTs: this.form.beginTime,
              endTs: this.form.endTime
            }
            let loading = this.$loading()
            this.$patch(`/slogan/${this.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(
                    this.$i18n.t('lang.lab_modify_success')
                  )
                  this.commit()
                  this.show = false
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        }
      })
    },
    // 查询按钮
    commit() {
      this.pageNum = 1
      this.list()
    },
    // 删除
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$delete(`/slogan/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    }
  }
}
</script>

<style lang="scss">
.posterList .el-input--prefix .el-input__inner {
  width: 440px;
}
.el-tooltip__popper.is-light {
  max-width: 300px;
}
</style>
